<mat-toolbar>
  <mat-toolbar-row class="justify-content-between">
    <button mat-icon-button (click)="toggleSidebar()" class="header-left">
      <mat-icon class="toggle">menu</mat-icon>
    </button>
    <div class="header-center">
      <!-- Center the account name -->
      <span class="user-name"><i class="fas fa-user-circle" style="font-size:large ;"></i> {{erpUser?.['account_name']}}</span>
    </div>
    <div class="header-right">
      <div class="col-4 mt-3 align-items-center">
        <button mat-icon-button >
          <mat-icon class="toggle">notifications_active</mat-icon>
        </button>
        <button mat-icon-button>
          <mat-icon class="toggle"> message</mat-icon>
        </button>
        <button mat-icon-button routerLink="/app-home">
          <mat-icon class="toggle">dashboard</mat-icon>
        </button>
      </div>
      <div class="col-8">
       <ul class="row m-0 align-items-left">

        <li>
          <button mat-button [matMenuTriggerFor]="menu" class="user mt-2 d-flex align-items-center">
            <img src="./assets/user.jpg" alt="" class="user-image mr-1 p-2" />

            {{erpUser?.['party_name']}}
            <mat-icon class="user-image-icon ml-1">keyboard_arrow_down</mat-icon>
          </button>
          <mat-menu #menu="matMenu">
            <button mat-menu-item (click)="logOut()">
              <mat-icon>exit_to_app</mat-icon>
              Logout
            </button>
          </mat-menu>
        </li>
      </ul>
      </div>


     
    </div>

  </mat-toolbar-row>
</mat-toolbar>
